import _Empty from './empty';
import withInstall from '../utils/withInstall';

import './style';

export * from './type';

export const Empty = withInstall(_Empty);

export default Empty;
